// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   Examples Page
   Inherits look & feel from LandingPage.css
   =================================== */

.ex-page {
  padding-bottom: 120px;
}

/* ─── Hero ─── */

.ex-hero {
  max-width: 960px;
  margin: 0 auto;
  padding: clamp(64px, 14vh, 140px) clamp(20px, 5vw, 32px) 48px;
  text-align: center;
}

.ex-hero-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: clamp(40px, 6vw, 72px);
  line-height: 1.05;
  color: var(--color-text-primary);
  margin: 18px 0 20px;
  letter-spacing: -0.01em;
}

.ex-hero-title-em {
  font-style: italic;
}

.ex-hero-subtitle {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: clamp(15px, 1.6vw, 17px);
  line-height: 1.55;
  color: var(--color-text-secondary);
  margin: 0 auto 28px;
  max-width: 620px;
}

.ex-hero-cta {
  display: flex;
  justify-content: center;
  margin: 4px 0 28px;
}

.ex-hero-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: var(--color-bg-root);
  background: var(--color-text-primary);
  padding: 12px 24px;
  border-radius: 999px;
  text-decoration: none;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.ex-hero-cta-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.ex-hero-nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
}

.ex-hero-chip {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-secondary);
  padding: 7px 14px;
  border-radius: 999px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  text-decoration: none;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.ex-hero-chip:hover {
  color: var(--color-text-primary);
  background: var(--color-bg-user-bubble);
  border-color: var(--color-border-user-bubble);
}

/* ─── Categories ─── */

.ex-categories {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 48px);
  display: flex;
  flex-direction: column;
  gap: clamp(56px, 8vh, 96px);
}

.ex-category {
  scroll-margin-top: 80px;
}

.ex-category-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
  padding: 0 4px;
}

.ex-category-head .ft-section-label {
  margin-bottom: 10px;
}

.ex-category-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: clamp(26px, 3vw, 36px);
  color: var(--color-text-primary);
  margin: 0 0 6px;
  line-height: 1.1;
}

.ex-category-desc {
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
  max-width: 520px;
  line-height: 1.5;
}

.ex-category-nav {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.ex-nav-btn {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease,
    transform 0.15s ease;
}

.ex-nav-btn:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-border-user-bubble);
}

.ex-nav-btn:active:not(:disabled) {
  transform: scale(0.96);
}

.ex-nav-btn:disabled {
  opacity: 0.35;
  cursor: default;
}

/* ─── Horizontal scroller ─── */

.ex-scroller {
  position: relative;
}

.ex-scroller::before,
.ex-scroller::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 12px;
  width: 48px;
  pointer-events: none;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.ex-scroller::before {
  left: 0;
  background: linear-gradient(to right, var(--color-bg-root), transparent);
}

.ex-scroller::after {
  right: 0;
  background: linear-gradient(to left, var(--color-bg-root), transparent);
}

.ex-scroller--fade-l::before { opacity: 1; }
.ex-scroller--fade-r::after { opacity: 1; }

.ex-scroller-track {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px 4px 16px;
  scroll-snap-type: x mandatory;
  scrollbar-width: thin;
  scrollbar-color: var(--color-scrollbar-thumb) transparent;
  -webkit-overflow-scrolling: touch;
}

.ex-scroller-track::-webkit-scrollbar {
  height: 6px;
}
.ex-scroller-track::-webkit-scrollbar-thumb {
  background: var(--color-scrollbar-thumb);
  border-radius: 999px;
}
.ex-scroller-track::-webkit-scrollbar-track {
  background: transparent;
}

/* ─── Cards ─── */

.ex-card {
  position: relative;
  flex-shrink: 0;
  scroll-snap-align: start;
  border-radius: 14px;
  overflow: hidden;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: left;
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1),
    box-shadow 0.25s cubic-bezier(0.16, 1, 0.3, 1),
    border-color 0.2s ease;
}

.ex-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 32px -12px rgba(0, 0, 0, 0.22);
  border-color: var(--color-border-user-bubble);
}

.ex-card:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

.ex-card--portrait {
  width: clamp(220px, 26vw, 300px);
  aspect-ratio: 9 / 16;
}

.ex-card--landscape {
  width: clamp(380px, 46vw, 540px);
  aspect-ratio: 16 / 9;
}

.ex-card-media {
  position: absolute;
  inset: 0;
  background: var(--color-bg-input);
}

.ex-card-thumb,
.ex-card-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.25s ease, transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.ex-card-thumb--hidden {
  opacity: 0;
}

.ex-card-video {
  opacity: 0;
}

.ex-card-video--visible {
  opacity: 1;
}

.ex-card:hover .ex-card-thumb,
.ex-card:hover .ex-card-video {
  transform: scale(1.03);
}

/* Overlay lives on the bottom third */
.ex-card-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 33%;
  display: flex;
  align-items: flex-end;
  padding: 16px 18px;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.72) 0%,
    rgba(0, 0, 0, 0.35) 55%,
    transparent 100%
  );
  pointer-events: none;
}

.ex-card-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
}

/* Fixed-size plate so every logo normalizes to the same visual weight
   regardless of source aspect ratio. object-fit: contain keeps the mark
   proportional; the per-logo --logo-scale nudges compensate for internal
   PNG padding. */
.ex-card-logo-slot {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 180px;
  height: 48px;
  flex-shrink: 0;
}

.ex-card--landscape .ex-card-logo-slot {
  width: 220px;
  height: 60px;
}

.ex-card-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left center;
  transform: scale(var(--logo-scale, 1));
  transform-origin: left center;
  filter: brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35));
  opacity: 0.95;
}

.ex-card-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.2;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  letter-spacing: -0.005em;
}

.ex-card--landscape .ex-card-title {
  font-size: 24px;
}

/* Expand glyph */
.ex-card-expand {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  opacity: 0;
  transform: translateY(-2px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
}

.ex-card:hover .ex-card-expand {
  opacity: 1;
  transform: translateY(0);
}

/* ─── Modal overrides ─── */

.ex-modal-container {
  max-width: min(1100px, 96vw);
}

.ex-modal-container--portrait {
  max-width: min(460px, 92vw);
}

.ex-modal-content {
  background: #000;
  border-color: rgba(255, 255, 255, 0.08);
}

.ex-modal-player {
  width: 100%;
  display: block;
  background: #000;
}

.ex-modal-player--landscape {
  aspect-ratio: 16 / 9;
}

.ex-modal-player--portrait {
  aspect-ratio: 9 / 16;
  max-height: 80vh;
  margin: 0 auto;
}

.ex-modal-caption {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--color-bg-canvas-surface);
  border-top: 1px solid var(--color-border-input);
}

.ex-modal-logo-slot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 28px;
}

.ex-modal-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: scale(var(--logo-scale, 1));
}

.ex-modal-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: 18px;
  color: var(--color-text-primary);
}

/* ─── Responsive ─── */

@media (max-width: 820px) {
  .ex-category-head {
    flex-direction: column;
    align-items: stretch;
  }
  .ex-category-nav {
    display: none;
  }
  .ex-card--portrait {
    width: 62vw;
  }
  .ex-card--landscape {
    width: 86vw;
  }
  .ex-scroller::before,
  .ex-scroller::after {
    width: 24px;
  }
}

@media (max-width: 520px) {
  .ex-hero {
    padding-top: 48px;
  }
  .ex-categories {
    gap: 48px;
    padding: 0 16px;
  }
}

/* ─── Dark theme tweaks (logos tend to be dark-on-white) ─── */

@media (prefers-color-scheme: dark) {
  :root:not([data-theme]) .ex-card-logo {
    filter: brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.6));
  }
}
`, "",{"version":3,"sources":["webpack://./src/ExamplesPage.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAExC;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,mCAAmC;EACnC,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,0CAA0C;EAC1C,qBAAqB;EACrB,4EAA4E;AAC9E;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA,uBAAuB;;AAEvB;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,kCAAkC;EAClC,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB;wBACsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,gCAAgC;;AAEhC;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,wEAAwE;AAC1E;;AAEA;EACE,QAAQ;EACR,uEAAuE;AACzE;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,8BAA8B,UAAU,EAAE;;AAE1C;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,yDAAyD;EACzD,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;;AAEA,kBAAkB;;AAElB;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,yCAAyC;EACzC,eAAe;EACf,UAAU;EACV,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB;;0BAEwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4EAA4E;AAC9E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;;;iBAGiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;EACtC,6BAA6B;EAC7B,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,0BAA0B;EAC1B,kCAAkC;EAClC,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,4BAA4B;;AAE5B;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA,uBAAuB;;AAEvB;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA,+DAA+D;;AAE/D;EACE;IACE,yEAAyE;EAC3E;AACF","sourcesContent":["/* ===================================\n   Examples Page\n   Inherits look & feel from LandingPage.css\n   =================================== */\n\n.ex-page {\n  padding-bottom: 120px;\n}\n\n/* ─── Hero ─── */\n\n.ex-hero {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: clamp(64px, 14vh, 140px) clamp(20px, 5vw, 32px) 48px;\n  text-align: center;\n}\n\n.ex-hero-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: clamp(40px, 6vw, 72px);\n  line-height: 1.05;\n  color: var(--color-text-primary);\n  margin: 18px 0 20px;\n  letter-spacing: -0.01em;\n}\n\n.ex-hero-title-em {\n  font-style: italic;\n}\n\n.ex-hero-subtitle {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: clamp(15px, 1.6vw, 17px);\n  line-height: 1.55;\n  color: var(--color-text-secondary);\n  margin: 0 auto 28px;\n  max-width: 620px;\n}\n\n.ex-hero-cta {\n  display: flex;\n  justify-content: center;\n  margin: 4px 0 28px;\n}\n\n.ex-hero-cta-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-bg-root);\n  background: var(--color-text-primary);\n  padding: 12px 24px;\n  border-radius: 999px;\n  text-decoration: none;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.ex-hero-cta-btn:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.ex-hero-nav {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.ex-hero-chip {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  padding: 7px 14px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  text-decoration: none;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.ex-hero-chip:hover {\n  color: var(--color-text-primary);\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-border-user-bubble);\n}\n\n/* ─── Categories ─── */\n\n.ex-categories {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 clamp(20px, 4vw, 48px);\n  display: flex;\n  flex-direction: column;\n  gap: clamp(56px, 8vh, 96px);\n}\n\n.ex-category {\n  scroll-margin-top: 80px;\n}\n\n.ex-category-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 20px;\n  padding: 0 4px;\n}\n\n.ex-category-head .ft-section-label {\n  margin-bottom: 10px;\n}\n\n.ex-category-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: clamp(26px, 3vw, 36px);\n  color: var(--color-text-primary);\n  margin: 0 0 6px;\n  line-height: 1.1;\n}\n\n.ex-category-desc {\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  margin: 0;\n  max-width: 520px;\n  line-height: 1.5;\n}\n\n.ex-category-nav {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.ex-nav-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease,\n    transform 0.15s ease;\n}\n\n.ex-nav-btn:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-border-user-bubble);\n}\n\n.ex-nav-btn:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.ex-nav-btn:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n/* ─── Horizontal scroller ─── */\n\n.ex-scroller {\n  position: relative;\n}\n\n.ex-scroller::before,\n.ex-scroller::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 12px;\n  width: 48px;\n  pointer-events: none;\n  z-index: 2;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.ex-scroller::before {\n  left: 0;\n  background: linear-gradient(to right, var(--color-bg-root), transparent);\n}\n\n.ex-scroller::after {\n  right: 0;\n  background: linear-gradient(to left, var(--color-bg-root), transparent);\n}\n\n.ex-scroller--fade-l::before { opacity: 1; }\n.ex-scroller--fade-r::after { opacity: 1; }\n\n.ex-scroller-track {\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 4px 4px 16px;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-scrollbar-thumb) transparent;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ex-scroller-track::-webkit-scrollbar {\n  height: 6px;\n}\n.ex-scroller-track::-webkit-scrollbar-thumb {\n  background: var(--color-scrollbar-thumb);\n  border-radius: 999px;\n}\n.ex-scroller-track::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* ─── Cards ─── */\n\n.ex-card {\n  position: relative;\n  flex-shrink: 0;\n  scroll-snap-align: start;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  cursor: pointer;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  text-align: left;\n  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1),\n    box-shadow 0.25s cubic-bezier(0.16, 1, 0.3, 1),\n    border-color 0.2s ease;\n}\n\n.ex-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 32px -12px rgba(0, 0, 0, 0.22);\n  border-color: var(--color-border-user-bubble);\n}\n\n.ex-card:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\n.ex-card--portrait {\n  width: clamp(220px, 26vw, 300px);\n  aspect-ratio: 9 / 16;\n}\n\n.ex-card--landscape {\n  width: clamp(380px, 46vw, 540px);\n  aspect-ratio: 16 / 9;\n}\n\n.ex-card-media {\n  position: absolute;\n  inset: 0;\n  background: var(--color-bg-input);\n}\n\n.ex-card-thumb,\n.ex-card-video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.25s ease, transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ex-card-thumb--hidden {\n  opacity: 0;\n}\n\n.ex-card-video {\n  opacity: 0;\n}\n\n.ex-card-video--visible {\n  opacity: 1;\n}\n\n.ex-card:hover .ex-card-thumb,\n.ex-card:hover .ex-card-video {\n  transform: scale(1.03);\n}\n\n/* Overlay lives on the bottom third */\n.ex-card-overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 33%;\n  display: flex;\n  align-items: flex-end;\n  padding: 16px 18px;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.72) 0%,\n    rgba(0, 0, 0, 0.35) 55%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n.ex-card-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  max-width: 100%;\n}\n\n/* Fixed-size plate so every logo normalizes to the same visual weight\n   regardless of source aspect ratio. object-fit: contain keeps the mark\n   proportional; the per-logo --logo-scale nudges compensate for internal\n   PNG padding. */\n.ex-card-logo-slot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 180px;\n  height: 48px;\n  flex-shrink: 0;\n}\n\n.ex-card--landscape .ex-card-logo-slot {\n  width: 220px;\n  height: 60px;\n}\n\n.ex-card-logo {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: left center;\n  transform: scale(var(--logo-scale, 1));\n  transform-origin: left center;\n  filter: brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35));\n  opacity: 0.95;\n}\n\n.ex-card-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1.2;\n  color: #fff;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n  letter-spacing: -0.005em;\n}\n\n.ex-card--landscape .ex-card-title {\n  font-size: 24px;\n}\n\n/* Expand glyph */\n.ex-card-expand {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.45);\n  color: #fff;\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  opacity: 0;\n  transform: translateY(-2px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  pointer-events: none;\n}\n\n.ex-card:hover .ex-card-expand {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* ─── Modal overrides ─── */\n\n.ex-modal-container {\n  max-width: min(1100px, 96vw);\n}\n\n.ex-modal-container--portrait {\n  max-width: min(460px, 92vw);\n}\n\n.ex-modal-content {\n  background: #000;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.ex-modal-player {\n  width: 100%;\n  display: block;\n  background: #000;\n}\n\n.ex-modal-player--landscape {\n  aspect-ratio: 16 / 9;\n}\n\n.ex-modal-player--portrait {\n  aspect-ratio: 9 / 16;\n  max-height: 80vh;\n  margin: 0 auto;\n}\n\n.ex-modal-caption {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 14px 20px;\n  background: var(--color-bg-canvas-surface);\n  border-top: 1px solid var(--color-border-input);\n}\n\n.ex-modal-logo-slot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 140px;\n  height: 28px;\n}\n\n.ex-modal-logo {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transform: scale(var(--logo-scale, 1));\n}\n\n.ex-modal-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: 18px;\n  color: var(--color-text-primary);\n}\n\n/* ─── Responsive ─── */\n\n@media (max-width: 820px) {\n  .ex-category-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .ex-category-nav {\n    display: none;\n  }\n  .ex-card--portrait {\n    width: 62vw;\n  }\n  .ex-card--landscape {\n    width: 86vw;\n  }\n  .ex-scroller::before,\n  .ex-scroller::after {\n    width: 24px;\n  }\n}\n\n@media (max-width: 520px) {\n  .ex-hero {\n    padding-top: 48px;\n  }\n  .ex-categories {\n    gap: 48px;\n    padding: 0 16px;\n  }\n}\n\n/* ─── Dark theme tweaks (logos tend to be dark-on-white) ─── */\n\n@media (prefers-color-scheme: dark) {\n  :root:not([data-theme]) .ex-card-logo {\n    filter: brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.6));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
